(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-responsive-slide-media')) {
    customElements.define('ds-responsive-slide-media', class extends HTMLElement {
      connectedCallback() {
        this.query = window.matchMedia('(min-width: 768px)');
        this.onResize = () => this.renderMedia();
        this.onVisibility = () => this.syncPlayback();
        this.query.addEventListener('change', this.onResize);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.slide = this.closest('.swiper-slide');
        this.slideObserver = new MutationObserver(() => this.syncPlayback());
        if (this.slide) this.slideObserver.observe(this.slide, { attributes: true, attributeFilter: ['class'] });
        this.inView = false;
        this.viewportObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.syncPlayback();
        });
        this.viewportObserver.observe(this);
        this.renderMedia();
      }
      renderMedia() {
        const device = this.query.matches ? 'desktop' : 'mobile';
        const template = this.querySelector(`template[data-device="${device}"]`);
        const slot = this.querySelector('.ds-slide-media-slot');
        if (!template || !slot) return;
        if (this.video) {
          this.video.pause();
          this.video.removeAttribute('src');
          this.video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
          this.video.load();
        }
        slot.replaceChildren(template.content.cloneNode(true));
        this.video = slot.querySelector('video');
        if (this.video) {
          this.video.muted = true;
          this.video.playsInline = true;
        }
        this.syncPlayback();
      }
      syncPlayback() {
        if (!this.video) return;
        const swiper = this.closest('slide-section');
        const active = !swiper?.classList.contains('swiper-initialized') || this.slide?.classList.contains('swiper-slide-active');
        if (this.inView && active && !document.hidden) {
          const play = this.video.play();
          if (play) play.catch(() => {});
        } else {
          this.video.pause();
        }
      }
      disconnectedCallback() {
        this.query?.removeEventListener('change', this.onResize);
        document.removeEventListener('visibilitychange', this.onVisibility);
        this.slideObserver?.disconnect();
        this.viewportObserver?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
